import { render, staticRenderFns } from "./PosCounterSidebar.vue?vue&type=template&id=cc0dba0c&"
import script from "./PosCounterSidebar.vue?vue&type=script&lang=js&"
export * from "./PosCounterSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports